<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ $t('sort_category') }}
      v-spacer
      v-btn(icon @click="showDialog = false" small color="primary")
        v-icon mdi-close
    v-divider

    v-card-text.primary--text.px-8.py-4
      div {{ $t('rearrange_your_category') }}
      draggable(handle=".handle" :list="categories" @start="drag = true" @end="endMove" :move="checkMove")
        v-card.round-xl.pa-4.mt-3(outlined v-for="category in categories" :key="category.id")
          .d-flex.align-center
            v-icon.handle.cursor-grab(color="neutral500") $yzi-dots-grid-02
            .ml-3 {{ category.name }}
    v-divider

    v-card-actions.py-4.px-6
      v-btn.button-md.underline.px-0(@click="showDialog = false" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="done" color="primary" depressed) {{ $t('done') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import draggable from 'vuedraggable'

export default {
  name: 'SortCategoryDialog',
  components: { draggable },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    categories: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    isSaving: false,
    drag: false,
    fromCategoryId: null,
    params: {}
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    done () {
      this.showDialog = false
    },
    endMove () {
      this.drag = false
      if (!this.fromCategoryId) {
        return
      }
      if (this.fromCategoryId === this.params.category) {
        return
      }
      this.$axios.post(`/product_categories/${this.fromCategoryId}/move/`, this.params).catch(() => {})
    },
    checkMove (e) {
      let fromCategory = this.categories[e.draggedContext.index]
      let toCategory = this.categories[e.draggedContext.futureIndex]
      this.params = {
        category: toCategory.id,
        direction: e.draggedContext.futureIndex > e.draggedContext.index ? 'down' : 'up'
      }
      this.fromCategoryId = fromCategory.id
    }
  }
}
</script>
